"use strict";

import angular from "angular";

angular.module("nucont.authentication", ["nucont.shared"]);
require("./authentication.routes");
